import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { useLogger } from '@agyletime/vue-3-common/src/composables/logger';
import type { Team } from '@/components/TeamAndSchedule/types/Team';

export async function getAllTeams(supervisorId = 0): Promise<Team[]> {
    try {
        // build request options; fetchFromLambda expects cacheKey as string when used
        const config: { cacheKey?: string; params: Record<string, unknown>; paginate?: boolean } = { params: { active: 'Y' } };

        // Match the manage roster permission restriction logic
        if (supervisorId > 0) {
            config.params.supervisorId = supervisorId;
        }

        // Use same API endpoint as AngularJS app
        const teams = await fetchFromLambda('/organisation/teams', config as unknown as RequestInit);
        return (teams as Team[]).sort((a, b) => a.name.localeCompare(b.name));
    } catch {
        return [];
    }
}

// Match TeamService.getMyTeam() pattern
export async function getMyTeam(options = { cache: true }): Promise<Team | null> {
    try {
        const fetchConfig: RequestInit = {};
        if (options.cache !== undefined) {
            fetchConfig.cache = options.cache ? 'default' : 'no-store';
        }
        const team = await fetchFromLambda('/organisation/teams/me', fetchConfig);
        return team as Team;
    } catch (error) {
        const logger = useLogger('teamService');
        logger.error('Failed to fetch my team:', error);
        return null;
    }
}